module.exports = __webpack_public_path__ + "static/media/submarine_path.9425ca19.gif";